import http from "../../../helpers/http";
import Loader from "../../../helpers/loader";
import Alert from "../../../helpers/alert";

export function canSignMedicalRecord(medicalRecord, schedule) {
  if (!medicalRecord || !schedule) {
    return false;
  }

  if (medicalRecord.shared_readonly) {
    return false;
  }

  return Number(medicalRecord.id_prof) === Number(schedule.id_prof);
}

export function medicalRecordPrintUrl({ professionalId, patientId, medrecId }) {
  return `/professionals/${professionalId}/patients/${patientId}/medical-records/${medrecId}`;
}

export function printMedicalRecordPdf({ professionalId, patientId, medrecId, certifierId }) {
  if (!professionalId || !patientId || !medrecId) {
    Alert.toastError('Não foi possível identificar o prontuário para impressão.');
    return Promise.reject();
  }

  Loader.show('Gerando PDF', 'Aguarde...');

  const payload = {};
  if (certifierId) {
    payload.certifier_id = certifierId;
  }

  return http.post(`${medicalRecordPrintUrl({ professionalId, patientId, medrecId })}/print`, payload)
    .then((response) => {
      Loader.close();
      const data = response.data;
      const fileName = data.file_name || data.authenticator?.file?.file_name;
      const signed = !!data.medical_record?.medrec_signed;

      return {
        pdfSource: `data:application/pdf;base64,${data.file_base64}`,
        pdfFileName: fileName,
        signed,
        medicalRecord: data.medical_record,
        fileBase64: data.file_base64,
        authenticator: data.authenticator,
        data,
      };
    }).catch((error) => {
      Loader.close();
      Alert.toastError(error.response?.data?.message || 'Erro ao gerar o PDF do prontuário.');
      throw error;
    });
}

export function uploadSignedMedicalRecordPdf({ professionalId, patientId, medrecId, formData }) {
  return http.post(
    `${medicalRecordPrintUrl({ professionalId, patientId, medrecId })}/upload-signed`,
    formData,
  );
}

export function showMedicalRecordPdf(viewerId) {
  const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(viewerId));
  modal.show();
}
